import React from "react";
import classNames from "classnames";
import { SectionProps } from "../../utils/SectionProps";
import Image from "../elements/Image";
import Header from "../layout/HeaderBackPrevious.js";
import { Link } from "react-router-dom";

const propTypes = {
  ...SectionProps.types,
};

const defaultProps = {
  ...SectionProps.defaults,
};

const PreviousHero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {
  const outerClasses = classNames(
    "hero section center-content",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "hero-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  const tilesClasses = classNames(
    "display: inline-block",
    "flex-wrap: wrap",
    "tiles-wrap center-content",
    "border-style: solid",
    pushLeft && "push-left"
  );

  const divStyle = {
    margin: "0 auto",
    width: "355px",
  };

  return (
    <section {...props} className={outerClasses}>
      <Header />
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <h1
              className="mt-0 mb-16 reveal-from-bottom"
              data-reveal-delay="200"
            >
              <span className="text-color-primary">Eerdere Video's</span>
            </h1>

            <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
              Interviews met eerdere gastdocenten
            </p>
          </div>

          {
            // Old Videos
          }

          <div
            className="reveal-from-bottom"
            data-reveal-value="20px"
            data-reveal-delay="600"
          >
            <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
              <Link to="/JoSterckx">Eerste docent - Jo Sterckx</Link>
            </p>

            <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
              <Link to="/AnneBaude">Tweede docent - Anne Baude</Link>
            </p>

            <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
              <Link to="/PatriciaCouto">Derde docent - Patricia Couto</Link>
            </p>

            <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
              <Link to="/FrancoParis">Vierde docent - Franco Paris</Link>
            </p>

            <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
              <Link to="/AnnevanRaemdonck">
                Vijfde docent - Anne van Raemdonck
              </Link>
            </p>

            <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
              <Link to="/PaolaGentile">Zesde docent - Paola Gentile</Link>
            </p>

            <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
              <Link to="/PatrickRoca">Zevende docent - Patrick Roca</Link>
            </p>

            <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="200">
              Tweede reeks: alumni
            </p>

            <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="100">
              <Link to="/JoanaSeixas">Eerste docent - Joana Seixas</Link>
            </p>
            <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="100">
              <Link to="/AlejandraSanz">Tweede docent - Alejandra Sanz</Link>
            </p>
            <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="100">
              <Link to="/MatildeSoliani">Derde docent - Matilde Soliani</Link>
            </p>
            <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="100">
              <Link to="/FrancescoPanzeri">
                Vierde docent - Francesco Panzeri
              </Link>
            </p>

            <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="200">
              Derde reeks: tolken en vertalen{" "}
            </p>

            <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
              <Link to="/NielsTimmermans">
                Eerste docent - Niels Timmermans{" "}
              </Link>
            </p>

            <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
              <Link to="/VeroniqueDenis">Tweede docent - Veronique Denis </Link>
            </p>

            <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
              <Link to="/KrisztinaSoos">Derde docent - Krisztina Soós </Link>
            </p>

            <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
              <Link to="/AlessandroColagiovanni">
                Vierde docent - Alessandro Colagiovanni{" "}
              </Link>
            </p>
            <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
              <Link to="/HeidiSalaets">Vijfde docent - Heidi Salaets </Link>
            </p>
            <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
              <Link to="/AlricvandenBroek">
                Zesde docent - Alric van den Broek{" "}
              </Link>
            </p>
          </div>

          <div>
            <div className={tilesClasses} style={divStyle}>
              <a style={{ width: "50%" }} href="https://taalunie.org/">
                <Image
                  src={require("./../../assets/images/Nederlandse_Taalunie.jpeg")}
                  alt="Open"
                  width={100}
                  height={52}
                />
              </a>{" "}
              <Image
                src={require("./../../assets/images/Nederlandse_Taalunie.jpeg")}
                alt="Open"
                width={0}
                height={0}
              />
              <a style={{ width: "50%" }} href="http://mediterraned.org/">
                <Image
                  src={require("./../../assets/images/Mediterraned.png")}
                  alt="Open"
                  width={100}
                  height={52}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

PreviousHero.propTypes = propTypes;
PreviousHero.defaultProps = defaultProps;

export default PreviousHero;
